import React from 'react';
import { PlusCircle, FileSearch } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const QuickActions = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-white rounded-xl shadow p-6">
      <h3 className="text-lg font-semibold text-slate-800 mb-4">
        Quick Actions
      </h3>

      <div className="flex flex-wrap gap-4">
        <button
          onClick={() => navigate('/hr/form')}
          className="flex items-center gap-3 px-5 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition"
        >
          <FileSearch size={20} />
          View Forms
        </button>
      </div>
    </div>
  );
};

export default QuickActions;
